import React, { useState } from 'react';
import { useLang } from '../i18n/LangContext';

/**
 * 인라인 힌트 컴포넌트
 * hintKey  : localStorage 키 (ddabak_hint_<hintKey>)
 * children : 힌트 텍스트 (문자열 또는 JSX)
 * arrow    : 'top' | 'bottom' | 'none' (기본 none)
 * mb / mt  : margin-bottom / top (기본 12px / 0)
 * zh       : V111 — 중국어 문구. 표시 언어가 中文이면 children 대신 이걸 보여준다.
 *            (안내문은 JSX라 ui.js 사전으로 못 바꾸므로 사용처에서 직접 넘긴다)
 */
export default function Hint({ hintKey, children, zh, arrow = 'none', mb = 12, mt = 0 }) {
  const { lang } = useLang();
  const [visible, setVisible] = useState(() => {
    return !localStorage.getItem('ddabak_hint_' + hintKey);
  });

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem('ddabak_hint_' + hintKey, '1');
    setVisible(false);
  };

  return (
    <div style={{ position: 'relative', marginBottom: mb, marginTop: mt }}>
      {arrow === 'top' && (
        <div style={{
          position: 'absolute', top: '-7px', left: '20px',
          width: 0, height: 0,
          borderLeft: '7px solid transparent',
          borderRight: '7px solid transparent',
          borderBottom: '7px solid #E4E4E7',
        }} />
      )}

      <div style={{
        background: '#FAFAFA',
        border: '1px solid #F4F4F5',
        borderRadius: '10px',
        padding: '10px 36px 10px 12px',
        position: 'relative',
        lineHeight: 1.65,
      }}>
        <span style={{ fontSize: '13px', color: '#9A3412', display: 'block' }}>
          <span style={{ marginRight: '6px' }}>💡</span>
          {lang === 'zh' && zh ? zh : children}
        </span>

        <button
          onClick={dismiss}
          title={lang === 'zh' ? '关闭' : '닫기'}
          style={{
            position: 'absolute', top: '8px', right: '8px',
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#FED7AA', fontSize: '15px', lineHeight: 1, padding: '2px 4px',
            fontWeight: '700',
          }}>
          ✕
        </button>
      </div>

      {arrow === 'bottom' && (
        <div style={{
          position: 'absolute', bottom: '-7px', left: '20px',
          width: 0, height: 0,
          borderLeft: '7px solid transparent',
          borderRight: '7px solid transparent',
          borderTop: '7px solid #E4E4E7',
        }} />
      )}
    </div>
  );
}

/** localStorage에 저장된 힌트 기록을 모두 지운다 (설정에서 재설정 용도) */
export function resetAllHints() {
  Object.keys(localStorage)
    .filter(k => k.startsWith('ddabak_hint_'))
    .forEach(k => localStorage.removeItem(k));
}
